export const searchItems = [
  // General
  {
    label: "Dashboard", labelFr: "Tableau de bord", labelAr: "لوحة التحكم",
    category: "General", path: "/home",
    keywords: ["dashboard", "home", "overview", "main", "tableau de bord", "accueil", "لوحة التحكم", "الرئيسية", "نظرة عامة"]
  },

  // CRM
  {
    label: "CRM", labelFr: "CRM", labelAr: "إدارة علاقات العملاء",
    category: "CRM", path: "/crm/home",
    keywords: ["crm", "home", "customer relationship", "إدارة علاقات العملاء", "علاقات العملاء", "gestion relation client"]
  },
  {
    label: "Leads", labelFr: "Prospects", labelAr: "العملاء المحتملون",
    category: "CRM", path: "/crm/leads",
    keywords: ["leads", "prospects", "pipeline", "العملاء المحتملون", "عملاء محتملون", "prospects", "piste"]
  },
  {
    label: "Create Lead", labelFr: "Créer un prospect", labelAr: "إنشاء عميل محتمل",
    category: "CRM", path: "/crm/leads/create",
    keywords: ["create lead", "new lead", "add lead", "nouveau prospect", "créer prospect", "إنشاء عميل محتمل", "عميل محتمل جديد", "إضافة عميل محتمل"]
  },
  {
    label: "Customers", labelFr: "Clients", labelAr: "العملاء",
    category: "CRM", path: "/crm/customers",
    keywords: ["customers", "clients", "contacts", "العملاء", "عملاء", "clients", "clientèle"]
  },
  {
    label: "Create Customer", labelFr: "Créer un client", labelAr: "إنشاء عميل",
    category: "CRM", path: "/crm/customers/create",
    keywords: ["create customer", "new customer", "add customer", "nouveau client", "créer client", "إنشاء عميل", "عميل جديد", "إضافة عميل"]
  },
  {
    label: "Calls", labelFr: "Appels", labelAr: "المكالمات",
    category: "CRM", path: "/crm/calls",
    keywords: ["calls", "phone", "log call", "appels", "téléphone", "المكالمات", "مكالمات", "هاتف"]
  },
  {
    label: "Create Call", labelFr: "Créer un appel", labelAr: "إنشاء مكالمة",
    category: "CRM", path: "/crm/calls/create",
    keywords: ["create call", "new call", "log call", "nouvel appel", "créer appel", "إنشاء مكالمة", "مكالمة جديدة", "تسجيل مكالمة"]
  },
  {
    label: "Tasks", labelFr: "Tâches", labelAr: "المهام",
    category: "CRM", path: "/crm/tasks",
    keywords: ["tasks", "to-do", "todo", "activity", "tâches", "activité", "المهام", "مهام", "نشاط"]
  },
  {
    label: "Create Task", labelFr: "Créer une tâche", labelAr: "إنشاء مهمة",
    category: "CRM", path: "/crm/tasks/create",
    keywords: ["create task", "new task", "add task", "nouvelle tâche", "créer tâche", "إنشاء مهمة", "مهمة جديدة", "إضافة مهمة"]
  },
  {
    label: "Meetings", labelFr: "Réunions", labelAr: "الاجتماعات",
    category: "CRM", path: "/crm/meetings",
    keywords: ["meetings", "appointments", "schedule", "réunions", "rendez-vous", "الاجتماعات", "اجتماعات", "مواعيد"]
  },
  {
    label: "Create Meeting", labelFr: "Créer une réunion", labelAr: "إنشاء اجتماع",
    category: "CRM", path: "/crm/meetings/create",
    keywords: ["create meeting", "new meeting", "schedule meeting", "nouvelle réunion", "créer réunion", "إنشاء اجتماع", "اجتماع جديد", "جدولة اجتماع"]
  },

  // Sales
  {
    label: "Sales", labelFr: "Ventes", labelAr: "المبيعات",
    category: "Sales", path: "/sales/home",
    keywords: ["sales", "revenue", "ventes", "chiffre d'affaires", "المبيعات", "مبيعات", "الإيرادات"]
  },
  {
    label: "Quotes", labelFr: "Devis", labelAr: "عروض الأسعار",
    category: "Sales", path: "/sales/quotes",
    keywords: ["quotes", "quotations", "estimates", "proposals", "devis", "propositions", "عروض الأسعار", "عروض", "تقديرات"]
  },
  {
    label: "Create Quote", labelFr: "Créer un devis", labelAr: "إنشاء عرض سعر",
    category: "Sales", path: "/sales/quotes/create",
    keywords: ["create quote", "new quote", "add quote", "nouveau devis", "créer devis", "إنشاء عرض سعر", "عرض سعر جديد", "إضافة عرض"]
  },
  {
    label: "Invoices", labelFr: "Factures", labelAr: "الفواتير",
    category: "Sales", path: "/sales/invoices",
    keywords: ["invoices", "billing", "factures", "facturation", "الفواتير", "فواتير", "فاتورة"]
  },
  {
    label: "Create Invoice", labelFr: "Créer une facture", labelAr: "إنشاء فاتورة",
    category: "Sales", path: "/sales/invoices/create",
    keywords: ["create invoice", "new invoice", "add invoice", "nouvelle facture", "créer facture", "إنشاء فاتورة", "فاتورة جديدة", "إضافة فاتورة"]
  },
  {
    label: "Recurring Invoices", labelFr: "Factures récurrentes", labelAr: "الفواتير المتكررة",
    category: "Sales", path: "/sales/recurring-invoices",
    keywords: ["recurring invoices", "subscriptions", "recurring", "repeat", "factures récurrentes", "abonnements", "récurrent", "الفواتير المتكررة", "فواتير متكررة", "اشتراكات"]
  },
  {
    label: "Create Recurring Invoice", labelFr: "Créer une facture récurrente", labelAr: "إنشاء فاتورة متكررة",
    category: "Sales", path: "/sales/recurring-invoices/create",
    keywords: ["create recurring invoice", "new recurring invoice", "subscription", "créer facture récurrente", "إنشاء فاتورة متكررة", "فاتورة متكررة جديدة"]
  },
  {
    label: "Sales Payments", labelFr: "Paiements reçus", labelAr: "مدفوعات المبيعات",
    category: "Sales", path: "/sales/payments",
    keywords: ["payments", "receipts", "received", "paiements", "reçus", "المدفوعات", "مدفوعات", "مقبوضات"]
  },
  {
    label: "Create Sales Payment", labelFr: "Créer un paiement", labelAr: "إنشاء دفعة",
    category: "Sales", path: "/sales/payments/create",
    keywords: ["create payment", "new payment", "add payment", "receipt", "nouveau paiement", "créer paiement", "إنشاء دفعة", "دفعة جديدة", "إضافة دفعة"]
  },

  // Purchases
  {
    label: "Purchases", labelFr: "Achats", labelAr: "المشتريات",
    category: "Purchases", path: "/purchases/home",
    keywords: ["purchases", "buying", "procurement", "achats", "approvisionnement", "المشتريات", "مشتريات", "المقتنيات"]
  },
  {
    label: "Bills", labelFr: "Factures fournisseurs", labelAr: "الفواتير المستلمة",
    category: "Purchases", path: "/purchases/bills",
    keywords: ["bills", "vendor bills", "supplier bills", "factures fournisseurs", "الفواتير المستلمة", "فواتير الموردين", "فواتير مستلمة"]
  },
  {
    label: "Create Bill", labelFr: "Créer une facture", labelAr: "إنشاء فاتورة",
    category: "Purchases", path: "/purchases/bills/create",
    keywords: ["create bill", "new bill", "add bill", "nouvelle facture", "créer facture fournisseur", "إنشاء فاتورة", "فاتورة جديدة"]
  },
  {
    label: "Purchase Orders", labelFr: "Bons de commande", labelAr: "أوامر الشراء",
    category: "Purchases", path: "/purchases/purchase-orders",
    keywords: ["purchase orders", "po", "orders", "bons de commande", "commandes", "أوامر الشراء", "طلبات الشراء", "أمر شراء"]
  },
  {
    label: "Create Purchase Order", labelFr: "Créer un bon de commande", labelAr: "إنشاء أمر شراء",
    category: "Purchases", path: "/purchases/purchase-orders/create",
    keywords: ["create purchase order", "new purchase order", "new po", "nouveau bon de commande", "créer commande", "إنشاء أمر شراء", "أمر شراء جديد"]
  },
  {
    label: "Purchase Payments", labelFr: "Paiements fournisseurs", labelAr: "مدفوعات المشتريات",
    category: "Purchases", path: "/purchases/payments",
    keywords: ["payments", "vendor payments", "paid", "paiements fournisseurs", "paiements achats", "مدفوعات المشتريات", "مدفوعات الموردين"]
  },
  {
    label: "Create Purchase Payment", labelFr: "Créer un paiement", labelAr: "إنشاء دفعة",
    category: "Purchases", path: "/purchases/payments/create",
    keywords: ["create payment", "new payment", "vendor payment", "nouveau paiement", "إنشاء دفعة", "دفعة مورد جديدة"]
  },
  {
    label: "Suppliers", labelFr: "Fournisseurs", labelAr: "الموردون",
    category: "Purchases", path: "/purchases/suppliers",
    keywords: ["suppliers", "vendors", "provider", "fournisseurs", "vendeurs", "الموردون", "موردون", "مورد"]
  },
  {
    label: "Create Supplier", labelFr: "Créer un fournisseur", labelAr: "إنشاء مورد",
    category: "Purchases", path: "/purchases/suppliers/create",
    keywords: ["create supplier", "new supplier", "add vendor", "nouveau fournisseur", "créer fournisseur", "إنشاء مورد", "مورد جديد", "إضافة مورد"]
  },

  // Inventory
  {
    label: "Inventory", labelFr: "Inventaire", labelAr: "المخزون",
    category: "Inventory", path: "/inventory/home",
    keywords: ["inventory", "warehouse", "stock", "inventaire", "entrepôt", "المخزون", "مخزون", "مستودع"]
  },
  {
    label: "Products", labelFr: "Produits", labelAr: "المنتجات",
    category: "Inventory", path: "/inventory/products",
    keywords: ["products", "items", "catalog", "goods", "produits", "articles", "catalogue", "المنتجات", "منتجات", "بضاعة", "كتالوج"]
  },
  {
    label: "Create Product", labelFr: "Créer un produit", labelAr: "إنشاء منتج",
    category: "Inventory", path: "/inventory/products/create",
    keywords: ["create product", "new product", "add item", "nouveau produit", "créer produit", "إنشاء منتج", "منتج جديد", "إضافة منتج"]
  },
  {
    label: "Categories", labelFr: "Catégories", labelAr: "التصنيفات",
    category: "Inventory", path: "/inventory/categories",
    keywords: ["categories", "product categories", "groups", "catégories", "groupes", "التصنيفات", "تصنيفات", "مجموعات"]
  },
  {
    label: "Warehouses", labelFr: "Entrepôts", labelAr: "المستودعات",
    category: "Inventory", path: "/inventory/warehouses",
    keywords: ["warehouses", "warehouse", "stock location", "depot", "store", "entrepôts", "entrepôt", "dépôt", "emplacement", "المستودعات", "مستودع", "مخزن"]
  },
  {
    label: "Stock Movements", labelFr: "Mouvements de stock", labelAr: "حركات المخزون",
    category: "Inventory", path: "/inventory/stock-movements",
    keywords: ["stock movements", "stock", "movements", "in out", "mouvements de stock", "mouvements", "حركات المخزون", "حركات", "مخزون"]
  },
  {
    label: "Stock Adjustments", labelFr: "Ajustements de stock", labelAr: "تسويات المخزون",
    category: "Inventory", path: "/inventory/stock-adjustments",
    keywords: ["stock adjustments", "adjustments", "correction", "ajustements de stock", "ajustements", "تسويات المخزون", "تسويات", "تصحيح مخزون"]
  },
  {
    label: "Create Stock Adjustment", labelFr: "Créer un ajustement de stock", labelAr: "إنشاء تسوية مخزون",
    category: "Inventory", path: "/inventory/stock-adjustments/create",
    keywords: ["create stock adjustment", "new adjustment", "correct stock", "nouvel ajustement", "créer ajustement", "إنشاء تسوية مخزون", "تسوية جديدة"]
  },

  // Accounting
  {
    label: "Accounting", labelFr: "Comptabilité", labelAr: "المحاسبة",
    category: "Accounting", path: "/accounting/home",
    keywords: ["accounting", "finance", "financial", "comptabilité", "finance", "المحاسبة", "محاسبة", "المالية"]
  },
  {
    label: "Expenses", labelFr: "Dépenses", labelAr: "المصروفات",
    category: "Accounting", path: "/accounting/expenses",
    keywords: ["expenses", "costs", "spending", "dépenses", "coûts", "المصروفات", "مصروفات", "النفقات", "تكاليف"]
  },
  {
    label: "Create Expense", labelFr: "Créer une dépense", labelAr: "إنشاء مصروف",
    category: "Accounting", path: "/accounting/expenses/create",
    keywords: ["create expense", "new expense", "add expense", "cost", "nouvelle dépense", "créer dépense", "إنشاء مصروف", "مصروف جديد", "إضافة مصروف"]
  },
  {
    label: "Chart of Accounts", labelFr: "Plan comptable", labelAr: "دليل الحسابات",
    category: "Accounting", path: "/accounting/chart",
    keywords: ["chart of accounts", "accounts", "coa", "ledger", "plan comptable", "comptes", "grand livre", "دليل الحسابات", "حسابات", "الدليل المحاسبي"]
  },
  {
    label: "Accounting Settings", labelFr: "Paramètres comptabilité", labelAr: "إعدادات المحاسبة",
    category: "Accounting", path: "/accounting/settings",
    keywords: ["accounting settings", "expense categories", "catégories comptables", "paramètres comptabilité", "إعدادات المحاسبة", "فئات المصروفات"]
  },

  // HR
  {
    label: "HR", labelFr: "RH", labelAr: "الموارد البشرية",
    category: "HR", path: "/hr/home",
    keywords: ["hr", "human resources", "people", "rh", "ressources humaines", "الموارد البشرية", "موارد بشرية", "شؤون الموظفين"]
  },
  {
    label: "Employees", labelFr: "Employés", labelAr: "الموظفون",
    category: "HR", path: "/hr/employees",
    keywords: ["employees", "staff", "workers", "team", "people", "employés", "personnel", "équipe", "الموظفون", "موظفون", "فريق العمل"]
  },
  {
    label: "Create Employee", labelFr: "Créer un employé", labelAr: "إنشاء موظف",
    category: "HR", path: "/hr/employees/create",
    keywords: ["create employee", "new employee", "hire", "onboard", "add staff", "nouvel employé", "créer employé", "embauche", "إنشاء موظف", "موظف جديد", "توظيف"]
  },
  {
    label: "Documents", labelFr: "Documents", labelAr: "الوثائق",
    category: "HR", path: "/hr/documents",
    keywords: ["documents", "files", "contracts", "documents", "fichiers", "contrats", "الوثائق", "وثائق", "ملفات", "عقود"]
  },
  {
    label: "Create Document", labelFr: "Créer un document", labelAr: "إنشاء وثيقة",
    category: "HR", path: "/hr/documents/create",
    keywords: ["create document", "new document", "upload document", "nouveau document", "créer document", "إنشاء وثيقة", "وثيقة جديدة", "رفع وثيقة"]
  },
  {
    label: "Attendance", labelFr: "Présence", labelAr: "الحضور والغياب",
    category: "HR", path: "/hr/attendance",
    keywords: ["attendance", "time", "hours", "checkin", "présence", "pointage", "heures", "الحضور والغياب", "حضور", "غياب", "دوام"]
  },
  {
    label: "Payroll", labelFr: "Paie", labelAr: "الرواتب",
    category: "HR", path: "/hr/payroll",
    keywords: ["payroll", "salary", "wages", "compensation", "pay", "paie", "salaires", "rémunération", "الرواتب", "رواتب", "أجور", "راتب"]
  },

  // Settings
  {
    label: "Settings", labelFr: "Paramètres", labelAr: "الإعدادات",
    category: "Settings", path: "/settings/home",
    keywords: ["settings", "configuration", "admin", "paramètres", "configuration", "administration", "الإعدادات", "إعدادات", "إدارة النظام"]
  },
  {
    label: "Company Info", labelFr: "Infos société", labelAr: "معلومات الشركة",
    category: "Settings", path: "/settings/company",
    keywords: ["company", "company info", "company details", "organization", "infos société", "société", "paramètres société", "معلومات الشركة", "بيانات الشركة", "إعدادات الشركة"]
  },
  {
    label: "Branches", labelFr: "Branches", labelAr: "الفروع",
    category: "Settings", path: "/settings/branches",
    keywords: ["branches", "branch", "locations", "sites", "offices", "succursales", "branche", "agences", "sites", "الفروع", "فرع", "مواقع"]
  },
  {
    label: "Users", labelFr: "Utilisateurs", labelAr: "المستخدمون",
    category: "Settings", path: "/settings/users",
    keywords: ["users", "team members", "accounts", "members", "utilisateurs", "membres", "comptes", "المستخدمون", "مستخدمون", "أعضاء الفريق"]
  },
  {
    label: "Create User", labelFr: "Créer un utilisateur", labelAr: "إنشاء مستخدم",
    category: "Settings", path: "/settings/users/create",
    keywords: ["create user", "new user", "add user", "invite", "nouvel utilisateur", "créer utilisateur", "inviter", "إنشاء مستخدم", "مستخدم جديد", "دعوة مستخدم"]
  },
  {
    label: "Roles & Permissions", labelFr: "Rôles & Permissions", labelAr: "الأدوار والصلاحيات",
    category: "Settings", path: "/settings/roles",
    keywords: ["roles", "permissions", "access control", "rights", "rôles", "permissions", "contrôle accès", "droits", "الأدوار والصلاحيات", "أدوار", "صلاحيات", "التحكم بالوصول"]
  },
  {
    label: "Integrations", labelFr: "Intégrations", labelAr: "التكاملات",
    category: "Settings", path: "/settings/integrations",
    keywords: ["integrations", "api", "connect", "third-party", "apps", "intégrations", "connexions", "تكاملات", "التكاملات", "ربط التطبيقات"]
  },
  {
    label: "Preferences", labelFr: "Préférences", labelAr: "التفضيلات",
    category: "Settings", path: "/settings/preferences",
    keywords: ["preferences", "general settings", "language", "theme", "préférences", "langue", "thème", "التفضيلات", "تفضيلات", "اللغة", "المظهر"]
  },
  {
    label: "Security Settings", labelFr: "Sécurité", labelAr: "الأمان",
    category: "Settings", path: "/settings/security",
    keywords: ["security", "2fa", "two-factor", "password", "authentication", "sécurité", "authentification", "mot de passe", "الأمان", "أمان", "المصادقة", "كلمة المرور", "المصادقة الثنائية"]
  },
  {
    label: "Billing & Plans", labelFr: "Facturation & Abonnement", labelAr: "الفواتير والاشتراك",
    category: "Settings", path: "/settings/billing",
    keywords: ["billing", "subscription", "plan", "payment", "pricing", "facturation", "abonnement", "plan tarifaire", "الفواتير والاشتراك", "اشتراك", "خطة", "فاتورة"]
  },
  {
    label: "Audit Logs", labelFr: "Journaux d'audit", labelAr: "سجلات المراجعة",
    category: "Settings", path: "/settings/audit-logs",
    keywords: ["audit logs", "activity", "history", "logs", "trail", "tracking", "journaux d'audit", "historique", "activité", "journaux", "سجلات المراجعة", "سجلات", "تتبع", "سجل النشاط"]
  },
];

export const categoryMeta = {
  General:    { color: "#6366f1", bg: "rgba(99,102,241,0.1)",    labelFr: "Général",       labelAr: "عام" },
  CRM:        { color: "#8b5cf6", bg: "rgba(139,92,246,0.1)",    labelFr: "CRM",           labelAr: "علاقات العملاء" },
  Sales:      { color: "#3b82f6", bg: "rgba(59,130,246,0.1)",    labelFr: "Ventes",        labelAr: "المبيعات" },
  Purchases:  { color: "#f59e0b", bg: "rgba(245,158,11,0.1)",    labelFr: "Achats",        labelAr: "المشتريات" },
  Inventory:  { color: "#10b981", bg: "rgba(16,185,129,0.1)",    labelFr: "Inventaire",    labelAr: "المخزون" },
  Accounting: { color: "#ef4444", bg: "rgba(239,68,68,0.1)",     labelFr: "Comptabilité",  labelAr: "المحاسبة" },
  HR:         { color: "#06b6d4", bg: "rgba(6,182,212,0.1)",     labelFr: "RH",            labelAr: "الموارد البشرية" },
  Settings:   { color: "#6b7280", bg: "rgba(107,114,128,0.1)",   labelFr: "Paramètres",    labelAr: "الإعدادات" },
};
